import { render, staticRenderFns } from "./BaseTLSchedule.vue?vue&type=template&id=71366812&"
import script from "./BaseTLSchedule.vue?vue&type=script&lang=ts&"
export * from "./BaseTLSchedule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports